const categories = [
  { id: "electronics", name: "3C 電子", icon: "FaLaptop", color: "#3b82f6" },
  { id: "clothing",    name: "服飾",    icon: "FaTshirt",  color: "#8b5cf6" },
  { id: "home",        name: "居家",    icon: "FaHome",    color: "#f59e0b" },
  { id: "books",       name: "書籍",    icon: "FaBook",    color: "#10b981" },
  { id: "sports",      name: "運動",    icon: "FaRunning", color: "#ef4444" },
];

export default categories;
